import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { firebase_auth } from '../firebase/firebaseConfig';
import './ProtectedRoute.css';

const ProtectedRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Verificar si hay una sesión activa en Firebase Auth
    const unsubscribe = onAuthStateChanged(firebase_auth, (user) => {
      if (user) {
        // Usuario está autenticado
        setAuthenticated(true);
        sessionStorage.setItem('adminAuthenticated', 'true');
      } else {
        // No hay usuario autenticado
        const isAuthenticated = sessionStorage.getItem('adminAuthenticated') === 'true';
        setAuthenticated(isAuthenticated);
      }
      setLoading(false);
    });

    // Limpiar suscripción al desmontar
    return () => unsubscribe();
  }, []);

  if (loading) {
    // Mostrar indicador de carga mientras se verifica la autenticación
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Verificando acceso...</p>
      </div>
    );
  }

  if (!authenticated) {
    // Redirigir al login si no está autenticado (ahora con la nueva ruta)
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Renderizar los componentes hijos si está autenticado
  return children;
};

export default ProtectedRoute; 